var map = {
	"./da.json": "bc76",
	"./de.json": "52a7",
	"./en.json": "b984",
	"./fr.json": "b017",
	"./pl.json": "c5f8",
	"./sv.json": "d1f9",
	"./zh-CN.json": "09e9",
	"./zh-TW.json": "0d94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24f4";